import React, { useEffect, useState } from "react";
import { paymentsApi } from "@/lib/api";
import { PageShell } from "./Overview";
import { toast } from "sonner";
import { Zap } from "lucide-react";

const SUBSCRIPTIONS = [
  { id: "compliance_monthly", name: "Compliance — Monthly", price: 49, desc: "Compliance engine + alerts, per entity." },
  { id: "compliance_annual", name: "Compliance — Annual", price: 499, desc: "Save 2 months. Priority support." },
  { id: "compliance_pro_monthly", name: "Compliance Pro — Monthly", price: 149, desc: "Everything + partner SLA priority + dedicated CSM." },
];

const Payments = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => { paymentsApi.list().then(setRows).catch(() => {}); }, []);

  const subscribe = async (pid) => {
    try {
      const { url } = await paymentsApi.checkout({ package_id: pid, origin_url: window.location.origin });
      window.location.href = url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start checkout");
    }
  };

  return (
    <PageShell title="Payments" subtitle="Invoices, subscriptions, and history">
      <div className="mb-10">
        <h2 className="h-display text-2xl mb-4">Compliance subscriptions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border-subtle border border-border-subtle">
          {SUBSCRIPTIONS.map((s) => (
            <div key={s.id} className="bg-surface-card p-6 flex flex-col" data-testid={`subscription-card-${s.id}`}>
              <div className="text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">Plan</div>
              <div className="h-display text-2xl mt-3">{s.name}</div>
              <div className="font-mono-accent text-artha-amber text-xl mt-3">${s.price}</div>
              <p className="text-sm text-ink-muted mt-3 flex-1">{s.desc}</p>
              <button onClick={() => subscribe(s.id)} data-testid={`subscribe-${s.id}`}
                className="mt-6 inline-flex items-center justify-center gap-2 bg-artha-amber text-artha-ink py-2.5 text-sm hover:bg-artha-cream transition-colors">
                <Zap size={14} /> Subscribe
              </button>
            </div>
          ))}
        </div>
      </div>

      <h2 className="h-display text-2xl mb-4">Transactions</h2>
      {rows.length === 0 ? (
        <div className="border border-dashed border-border-subtle p-12 text-center text-sm text-ink-muted">No transactions yet.</div>
      ) : (
        <div className="border border-border-subtle divide-y divide-border-subtle">
          {rows.map((r) => (
            <div key={r.session_id} className="grid grid-cols-12 gap-4 px-5 py-4 items-center" data-testid={`tx-row-${r.session_id}`}>
              <div className="col-span-5">
                <div className="text-sm">{r.purpose === "entity_registration" ? "Entity registration" : (r.package_id ? `Subscription · ${r.package_id}` : "Payment")}</div>
                <div className="text-xs font-mono-accent text-ink-muted mt-1">{new Date(r.created_at).toLocaleString()}</div>
              </div>
              <div className="col-span-3 font-mono-accent text-sm">${Number(r.amount).toFixed(2)} {r.currency?.toUpperCase()}</div>
              <div className="col-span-2 text-xs font-mono-accent uppercase tracking-[0.18em] text-ink-muted">{r.payment_status}</div>
              <div className="col-span-2 text-xs font-mono-accent text-ink-muted truncate">{r.session_id.slice(0, 12)}…</div>
            </div>
          ))}
        </div>
      )}
    </PageShell>
  );
};

export default Payments;
